export default __webpack_public_path__ + "static/media/42.23a69e63.svg";